import React, { useState } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function SelfAssessmentPage() {
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 5;
  const goToNextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };
  const goToPreviousStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };
  return <div className="w-full min-h-screen bg-[#f8f8f8] py-12 px-6" data-id="element-2247">
      <div className="max-w-4xl mx-auto" data-id="element-2248">
        {/* Back button */}
        <div className="mb-8" data-id="element-2249">
          <Link to="/assessment" className="flex items-center text-gray-600 hover:text-[#631bb7] transition-colors" data-id="element-2250">
            <ArrowLeftIcon size={20} className="mr-2" data-id="element-2251" />
            <span className="font-medium" data-id="element-2252">Back</span>
          </Link>
        </div>
        {/* Progress indicator */}
        <div className="mb-8" data-id="element-2253">
          <div className="flex justify-between items-center mb-2" data-id="element-2254">
            <span className="text-sm font-bold text-[#631bb7]" data-id="element-2255">
              Step {currentStep} of {totalSteps}
            </span>
            <span className="text-sm font-semibold text-gray-500" data-id="element-2256">
              {Math.round(currentStep / totalSteps * 100)}% Complete
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2257">
            <div className="bg-[#631bb7] h-2 rounded-full transition-all duration-300" style={{
            width: `${currentStep / totalSteps * 100}%`
          }} data-id="element-2258"></div>
          </div>
        </div>
        {/* Assessment Content */}
        <div className="bg-white rounded-2xl p-8 border-2 border-gray-200" data-id="element-2259">
          {currentStep === 1 && <div data-id="element-2260">
              <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6" data-id="element-2261">
                Let's start with the basics
              </h1>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-2262">
                We'll ask you a few questions to understand your current setup.
              </p>
              <div className="space-y-6 mb-8" data-id="element-2263">
                <div className="border-2 border-gray-200 rounded-xl p-6" data-id="element-2264">
                  <h3 className="text-xl font-bold text-[#111111] mb-4" data-id="element-2265">
                    Do you use a password manager?
                  </h3>
                  <div className="space-y-3" data-id="element-2266">
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-2267">
                      <input type="radio" name="password_manager" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-2268" />
                      <span className="font-medium" data-id="element-2269">
                        Yes, for all my accounts
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-2270">
                      <input type="radio" name="password_manager" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-2271" />
                      <span className="font-medium" data-id="element-2272">
                        Yes, for some accounts
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-2273">
                      <input type="radio" name="password_manager" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-2274" />
                      <span className="font-medium" data-id="element-2275">
                        No, I remember them or write them down
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-2276">
                      <input type="radio" name="password_manager" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-2277" />
                      <span className="font-medium" data-id="element-2278">
                        I'm not sure what that is
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex justify-end" data-id="element-2279">
                <button onClick={goToNextStep} className="bg-[#631bb7] text-white px-8 py-3 rounded-lg font-bold hover:bg-[#521099] transition-all shadow-md" data-id="element-2280">
                  Continue
                </button>
              </div>
            </div>}
          {currentStep === 2 && <div data-id="element-2281">
              <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6" data-id="element-2282">
                Two-factor authentication
              </h1>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-2283">
                This adds an extra layer of security to your accounts.
              </p>
              <div className="space-y-6 mb-8" data-id="element-2284">
                <div className="border-2 border-gray-200 rounded-xl p-6" data-id="element-2285">
                  <h3 className="text-xl font-bold text-[#111111] mb-4" data-id="element-2286">
                    Do you use two-factor authentication (2FA)?
                  </h3>
                  <div className="space-y-3" data-id="element-2287">
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-2288">
                      <input type="radio" name="two_factor" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-2289" />
                      <span className="font-medium" data-id="element-2290">
                        Yes, for all important accounts
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-2291">
                      <input type="radio" name="two_factor" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-2292" />
                      <span className="font-medium" data-id="element-2293">
                        Yes, for some accounts
                      </span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-2294">
                      <input type="radio" name="two_factor" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-2295" />
                      <span className="font-medium" data-id="element-2296">No, I don't use it</span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-2297">
                      <input type="radio" name="two_factor" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-2298" />
                      <span className="font-medium" data-id="element-2299">
                        I'm not sure what that is
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex justify-between" data-id="element-2300">
                <button onClick={goToPreviousStep} className="border-2 border-gray-300 text-[#111111] px-8 py-3 rounded-lg font-bold hover:border-[#631bb7] hover:text-[#631bb7] transition-colors" data-id="element-2301">
                  Back
                </button>
                <button onClick={goToNextStep} className="bg-[#631bb7] text-white px-8 py-3 rounded-lg font-bold hover:bg-[#521099] transition-all shadow-md" data-id="element-2302">
                  Continue
                </button>
              </div>
            </div>}
          {currentStep > 2 && <div data-id="element-2303">
              <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6" data-id="element-2304">
                Assessment Step {currentStep}
              </h1>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-2305">
                This is a placeholder for step {currentStep} of the assessment.
              </p>
              <div className="flex justify-between" data-id="element-2306">
                <button onClick={goToPreviousStep} className="border-2 border-gray-300 text-[#111111] px-8 py-3 rounded-lg font-bold hover:border-[#631bb7] hover:text-[#631bb7] transition-colors" data-id="element-2307">
                  Back
                </button>
                <button onClick={goToNextStep} className="bg-[#631bb7] text-white px-8 py-3 rounded-lg font-bold hover:bg-[#521099] transition-all shadow-md" data-id="element-2308">
                  Continue
                </button>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}